import httpService from '../httpService';
import { APIResponse } from '@/types';
import {
    AddWhiteListResponse,
    DeleteAPAndRTRequest,
    DeleteAPAndRTResponse,
    DeleteTagsRequest,
    DeleteTagsResponse,
    HandleFetchInfraDevicesRequest,
    HandleFetchInfraDevicesResponse,
    InfraTaskRequest,
    InfraTaskResponse,
    RegisterAPAndRTRequest,
    RegisterAPAndRTResponse,
    RegisterTagsRequest,
    RegisterTagsResponse,
    SetInstallationModeRequest,
    SetInstallationModeResponse,
} from '@/types/pages/storeManagement/registration';

const getInitiator = (): string => `webpage|${window.location.href}`;

export function setInstallationModeAPI(data: SetInstallationModeRequest): APIResponse<SetInstallationModeResponse> {
    return httpService.post('/infra/installation_mode', data);
}

export function handleFetchInfraDevicesAPI(
    data: HandleFetchInfraDevicesRequest,
    signal?: AbortSignal,
): APIResponse<HandleFetchInfraDevicesResponse> {
    return httpService.post('/infra/infra_devices', data, { signal });
}

export function registerAPAndRTAPI(data: RegisterAPAndRTRequest): APIResponse<RegisterAPAndRTResponse> {
    return httpService.post('/infra/register', {
        ...data,
        m2c_initiator: getInitiator(),
    });
}

export function registerTagAPI(data: RegisterTagsRequest): APIResponse<RegisterTagsResponse> {
    return httpService.post('/infra/register-tags', data);
}

export function infraTaskAPI(data: InfraTaskRequest): APIResponse<InfraTaskResponse> {
    return httpService.post('/infra/task', {
        ...data,
        m2c_initiator: getInitiator(),
    });
}

export function deleteTagsAPI(data: DeleteTagsRequest): APIResponse<DeleteTagsResponse> {
    return httpService.delete('/infra/remove-tags', { data });
}

export function deleteAPOrRTAPI(data: DeleteAPAndRTRequest): APIResponse<DeleteAPAndRTResponse> {
    return httpService.delete('/infra/remove', {
        data: {
            ...data,
            m2c_initiator: getInitiator(),
        },
    });
}

export function addToWhiteListAPI(storeId: number, list: string[]): APIResponse<AddWhiteListResponse> {
    return httpService.post(`/store/${storeId}/whitelist`, {
        record_type: 0,
        keywords: list,
    });
}
